import { Component, OnInit } from '@angular/core';
import { DataChangedService, HEADLINE_TYPE } from '../data-changed.service';

@Component({
    selector: 'app-settings-page',
    templateUrl: './settings-page.component.html',
    styleUrls: ['./settings-page.component.scss'],
    standalone: false
})
export class SettingsPageComponent implements OnInit {
  readonly settingsItems = [
    {
      label: 'Benutzer',
      description: 'Benutzerkonten und Berechtigungen verwalten',
      icon: 'manage_accounts',
      route: '/settings/user',
    },
    {
      label: 'Projekte',
      description: 'Projekte und ihre Auftraggeber-Zuordnungen verwalten',
      icon: 'folder',
      route: '/settings/projects',
    },
    {
      label: 'Auftraggeber',
      description: 'Auftraggeberdaten anzeigen und bearbeiten',
      icon: 'business',
      route: '/settings/clients',
    },
    {
      label: 'Zugriffsprotokolle',
      description: 'Systemzugriffe prüfen und exportieren',
      icon: 'history',
      route: '/settings/access-logs',
    },
  ];

  constructor(private dataChangedService: DataChangedService) {}

  ngOnInit(): void {
    this.dataChangedService.setHeadline({
      headline: 'Einstellungen',
      image: null,
      type: HEADLINE_TYPE.GENERIC,
    });
  }
}
